import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { AngularFileUploaderModule } from "angular-file-uploader";



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './admin/login.component';
import { SidebarComponent } from './admin/sidebar/sidebar.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { BanksComponent } from './admin/banks/banks.component';
import { UpdatesComponent } from './admin/updates/updates.component';
import { BankDetailComponent } from './admin/bank-detail/bank-detail.component';
import { UpdateDetailComponent } from './admin/update-detail/update-detail.component';
import { AddBankComponent } from './admin/add-bank/add-bank.component';
import { AddUpdateComponent } from './admin/add-update/add-update.component';
import { ResetComponent } from './admin/reset/reset.component';
import { PrivacyPolicyComponent } from './admin/privacy-policy/privacy-policy.component';
import { IndexComponent } from './landing-page/index/index.component';
import { AboutComponent } from './landing-page/about/about.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import {DatePipe} from '@angular/common';
import { AngularResizedEventModule } from 'angular-resize-event';





@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SidebarComponent,
    DashboardComponent,
    BanksComponent,
    UpdatesComponent,
    BankDetailComponent,
    UpdateDetailComponent,
    AddBankComponent,
    AddUpdateComponent,
    ResetComponent,
    PrivacyPolicyComponent,
    IndexComponent,
    AboutComponent
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    AngularFileUploaderModule,
    SlickCarouselModule,
    AngularResizedEventModule


  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
